import { GetBrokerPatientsListGroups } from '@/api/endpoints/Broker/BrokerPatient'
import { uploadFile } from '@/api/endpoints/file'
import { GetPatientAttachmentsTypes, UploadPatientMedicalAttachment } from '@/api/endpoints/Patient/PatientMedicalAttachment'
import { FileUpload, FileUploadPopup } from '@/components/Exporter'
import MultiSelect from '@/components/formFields/DropDown/Multiselect'
import Popup from '@/components/popup'
import { SUPPORTED_FORMATS } from '@/components/popups/filesUploadPopup/components/UploadFile'
import useFormData from '@/hooks/useFormData'
import { translate } from '@/utils/langUtils'
import { errorToast, successToast } from '@/utils/toasters'
import { useEffect, useState } from 'react'

const name = "upload-patient-medical-files"

export const defaultFiles = {
  "Lab Results Reports": "labReports",
  "X-ray/CT Image Reports": "xrayReports",
  "Medical Reports": "medicalReports",
}


const UploadPatientMedicalFiles = ({ setSelectedPatientId, modalID, patientId }) => {


  const [files, setFiles] = useState({})

  const [isLoading, setIsLoading] = useState(false)
  const [categories, setCategories] = useState(null)
  const [sCategory, setsCategory] = useState(null)

  const { getFormData } = useFormData()


  useEffect(() => {
    GetPatientAttachmentsTypes().then((res) => {
      setCategories(res.data)
    })
  }, [])

  const handleUpload = () => {

    setIsLoading(true)
    if (!sCategory) {
      setIsLoading(false)
      errorToast("please-select-category")
      return
    }

    const fileData = getFormData(files)

    uploadFile(fileData).then((res) => {

      UploadPatientMedicalAttachment({
        patientId: patientId,
        attchmentsIds: res.data,
      }).then(_ => {
        modalID.current?.click()
        successToast("operation-done-successfully")
        // we shall refetch here to update
        // GetBrokerPatientsListGroups()
      }).finally(_ => {
        handleClose()
        setIsLoading(false)
      })

    }).catch((err) => setIsLoading(false))
  }

  const handleClose = () => {
    setFiles([])
    setIsLoading(false)
    setsCategory(null)
    setSelectedPatientId(null)
  }

  return (
    <Popup className large={false} name={name} title={translate("upload-patient-medical-files")} onApply={handleUpload}
      modalID={modalID} btnName={isLoading ? "loading" : "upload"} resetAllFields={handleClose} >
      <MultiSelect options={categories}
        className='col-lg-12'
        label={'category'} isMulti={false}
        sOptions={sCategory} setSOptions={setsCategory} />

      <FileUpload
        accept={[SUPPORTED_FORMATS.image, SUPPORTED_FORMATS.pdf]}
        multiple
        value={files[defaultFiles[sCategory?.label]] || []}
        setValue={(value) => setFiles(prev => ({ ...prev, [defaultFiles[sCategory?.label]]: value }))}
        label={translate("upload-medical-files-hint")}
        isRequired={true}
      />
    </Popup>
  )
}

export default UploadPatientMedicalFiles